export const CAREER = 'career';
export const CAREERS = 'careers';



// WEBPACK FOOTER //
// src/store/modules/careers/mutation-types.js